import React, { FunctionComponent } from 'react';
import { IconProps } from '.';

const ArrowRight: FunctionComponent<IconProps> = ({ size = 24 }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 12H19" stroke="#253746" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 9L19 12L16 15" stroke="#253746" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export default ArrowRight;
